import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {LOOK_FEATURE_CONTENT} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import LookFeatureInfoContent from "./lookFeatureInfoContent";
import LookFeatureInfo3d from "./lookFeatureInfo3d";
import {setLookMoreInfoOpened} from "../../../../../actions/lookFunctions";
import LookFeatureInfoButtons from "./lookFeatureInfoButtons";
import LookFeatureInfoAug from "./lookFeatureInfoAug";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const LookFeatureInfo = (props) => {

  const {intl, lookActiveFeature, moreInfoOpened, moreInfoContent, setLookMoreInfoOpened, isMobile} = props;

  const backButtonClick = () => {
    Analytics.sendClickEvent(IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureInfoContentHeaderClose
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureInfoContentHeaderClose
    );
    setLookMoreInfoOpened("", LOOK_FEATURE_CONTENT.threeD);
  }

  const mainContent = () => {
    // if (!moreInfoOpened && !isMobile) { // always render on mobile
    if (!lookActiveFeature) { // always render on mobile
      return null
    }
    switch (moreInfoContent) {
      case LOOK_FEATURE_CONTENT.info:
      default:
        return <LookFeatureInfoContent/>
      case LOOK_FEATURE_CONTENT.threeD:
      case LOOK_FEATURE_CONTENT.aug:
        if (!moreInfoOpened) {
          return null
        }
        return (
          <div className="lk-info">
            {isMobile && !IS_PRODUCT_JOURNEY ? null : (
              <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                          className="look-icon look-icon--small lk-info__close"
                          onClick={backButtonClick}>
                <CloseIcon/>
              </IconButton>
            )}
            {moreInfoContent === LOOK_FEATURE_CONTENT.threeD ? <LookFeatureInfo3d/> : <LookFeatureInfoAug/>}
            {isMobile ? null : (
              <Fragment>
                <p className="lk-info__message">
                  <FormattedMessage id={moreInfoContent === LOOK_FEATURE_CONTENT.threeD ? "look.feature.info.text.3d" : "look.feature.info.text.aug"}/>
                </p>
                {moreInfoContent === LOOK_FEATURE_CONTENT.threeD ? (
                  <p className="lk-info__disclaimer">
                    <FormattedMessage id={"look.feature.info.disclaimer"}/>
                  </p>
                ) : null}
                <LookFeatureInfoButtons/>
              </Fragment>
            )}
            {isMobile && (moreInfoContent === LOOK_FEATURE_CONTENT.threeD) ? (
              <p className="lk-info__disclaimer">
                <FormattedMessage id={"look.feature.info.disclaimer"}/>
              </p>
            ) : null}
          </div>
        )
    }
  }

  const classNames = !IS_PRODUCT_JOURNEY && isMobile
    ? "lm-content lm-content--filters" + (!moreInfoOpened ? " lm-content--slide-up" : "")
    : "lm-content__info" + (moreInfoOpened ? " lm-content__info--active lm-content__info--" + moreInfoContent : "")

  return (
    <div className={classNames}>
      {mainContent()}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveFeature,
    moreInfoOpened,
    moreInfoContent,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookMoreInfoOpened
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookFeatureInfo)
)
